// e-Belge durum badge'i + "e-Belgeye Aktar" butonu — fatura/irsaliye modal header'ında.
// Yeni akış: kullanıcı "e-Belgeye Aktar" tıklar → 'draft' olarak Giden Faturalar listesine düşer.
// Asıl gönderim Giden Faturalar / Giden İrsaliyeler sayfasından "Gönder" ile yapılır.
import React, { useEffect, useState, useCallback } from 'react';
import api from '../services/api';
import { Button } from './ui';

const STATUS_COLORS = {
  draft:     { bg: 'rgba(245,158,11,0.15)',  clr: '#f59e0b', label: 'Taslak' },
  queued:    { bg: 'rgba(100,116,139,0.15)', clr: '#64748b', label: 'Kuyrukta' },
  sending:   { bg: 'rgba(59,130,246,0.15)',  clr: 'var(--info)', label: 'Gönderiliyor' },
  sent:      { bg: 'rgba(16,185,129,0.15)',  clr: 'var(--success)', label: 'Gönderildi ✓' },
  retrying:  { bg: 'rgba(245,158,11,0.15)',  clr: '#f59e0b', label: 'Tekrar Deneniyor' },
  failed:    { bg: 'rgba(239,68,68,0.15)',   clr: 'var(--danger)', label: 'Başarısız' },
  cancelled: { bg: 'rgba(100,116,139,0.15)', clr: '#64748b', label: 'İptal' },
};

const DOC_TYPE_LABELS = { eFatura:'e-Fatura', eArsiv:'e-Arşiv', eIhracat:'e-İhracat', eIrsaliye:'e-İrsaliye' };

export default function EDocumentBadge({ sourceTable, sourceId, canSend = true, blockReason = null }) {
  const [doc, setDoc] = useState(null);
  const [sending, setSending] = useState(false);

  const load = useCallback(async () => {
    if (!sourceId) return;
    try {
      const r = await api.get('/e-documents/list', { params: { source_table: sourceTable, source_id: sourceId } });
      if (r.data.success) setDoc(r.data.data?.[0] || null);
    } catch (e) {}
  }, [sourceTable, sourceId]);

  useEffect(() => { load(); }, [load]);

  const transferToEDoc = async () => {
    if (!window.confirm('Bu belge e-belge taslağı olarak hazırlanıp "Giden Faturalar" listesine düşürülecek.\n\nGöndermek için E-Belge Yönetimi → Giden Faturalar ekranından "Gönder" butonuna tıklayın.\n\nDevam edilsin mi?')) return;
    setSending(true);
    try {
      const r = await api.post('/e-documents/send', { source_table: sourceTable, source_id: sourceId, as_draft: true });
      if (r.data.success) {
        alert(`✓ Taslak hazırlandı (${DOC_TYPE_LABELS[r.data.doc_type] || r.data.doc_type}).\n\nE-Belge Yönetimi → Giden Faturalar ekranından "Gönder" butonuna tıklayın.`);
        load();
      }
    } catch (e) {
      alert(e.response?.data?.message || 'Hata');
    } finally { setSending(false); }
  };

  if (!doc) {
    // canSend false ve neden var ise bilgilendir; aksi halde gizle
    if (!canSend) {
      if (blockReason) {
        return (
          <span title={blockReason} style={{ fontSize: 11, padding: '3px 9px', borderRadius: 'var(--r-full)',
            background: 'rgba(100,116,139,0.12)', color: 'var(--text-tertiary)', fontWeight: 600, fontStyle: 'italic',
            cursor: 'help' }}>
            🔒 e-Belge için onay gerekli
          </span>
        );
      }
      return null;
    }
    return (
      <Button size="sm" variant="ghost" onClick={transferToEDoc} loading={sending} title="e-Belge taslağı olarak Giden Faturalar listesine aktar">
        📤 e-Belgeye Aktar
      </Button>
    );
  }

  const c = STATUS_COLORS[doc.status] || {};
  const typeLabel = DOC_TYPE_LABELS[doc.doc_type] || doc.doc_type;

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <span style={{ fontSize: 11, padding: '3px 8px', borderRadius: 4, background: 'rgba(99,102,241,0.12)', color: '#6366f1', fontWeight: 600 }}>
        {typeLabel}
      </span>
      <span style={{ fontSize: 11, padding: '3px 8px', borderRadius: 'var(--r-full)', background: c.bg, color: c.clr, fontWeight: 700 }} title={doc.status_message || ''}>
        {c.label}
      </span>
      {doc.gib_status && (
        <span style={{ fontSize: 11, padding: '3px 8px', borderRadius: 4, background: 'rgba(16,185,129,0.15)', color: 'var(--success)', fontWeight: 600 }}>
          GİB: {doc.gib_status}
        </span>
      )}
      <Button size="sm" variant="ghost" onClick={load} title="Yenile" iconOnly icon={<span>↻</span>} />
    </div>
  );
}
